import { TotalCardOrderStatus } from '../../dto/total-card-order-status';
import { Component, ViewChild, ChangeDetectorRef, OnDestroy, AfterViewInit } from '@angular/core';
import { RoleService } from '../../services/role.service';
import { MatTableGeneratorComponent } from '../../shared/mat-table-generator/mat-table-generator.component';
import { MultiCrudDataSource } from '../../table-datasouces/multi-crud.datasource';
import { TotalCardOrdersService } from '../services/total-card-orders.service';
import { TotalCardOrder } from '../../dto/total-card-order';
import { FileHelper } from '../../helpers/file-helper';
import { toDateString } from '../../providers/app-date-adapter';
import { MatButtonToggle } from '@angular/material/button-toggle';
import {Router} from '@angular/router';


@Component({
  selector: 'app-orders',
  templateUrl: './total-card-orders.component.html',
  styleUrls: ['./total-card-orders.component.css'],
})
export class TotalCardOrdersComponent implements OnDestroy, AfterViewInit {

  public dialogRemoveText = 'Removing orders you won\'t be able to navigate to order view from card details';

  public orderStatus = TotalCardOrderStatus;
  public orderStatuses: string[];
  public provenienceOrder: string;

  constructor(
    private router: Router,
    private roleService: RoleService,
    private ordersService: TotalCardOrdersService,
    private changeDetectorRefs: ChangeDetectorRef,
  ) { }


  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  @ViewChild(MatButtonToggle, { static: false }) allButton: MatButtonToggle;

  dataSource = new MultiCrudDataSource(this.ordersService);

  columns = [
    { columnDef: 'orderRef', header: 'Order Ref.', cell: (row: TotalCardOrder) => `${row.orderRef}` },
    { columnDef: 'company', header: 'Company Name', cell: (row: TotalCardOrder) => `${row.companyName}` },
    { columnDef: 'corporateForm', header: 'Corp. Form', cell: (row: TotalCardOrder) => `${row.corporateForm != null ? row.corporateForm.name : '' }` },
    { columnDef: 'city', header: 'Company City', cell: (row: TotalCardOrder) => `${row.city}` },
    { columnDef: 'countryName', header: 'Country', cell: (row: TotalCardOrder) => `${row.countryName}` },
    { columnDef: 'firstName', header: 'First Name', cell: (row: TotalCardOrder) => `${row.firstName}` },
    { columnDef: 'lastName', header: 'Last Name', cell: (row: TotalCardOrder) => `${row.lastName}` },
    { columnDef: 'email', header: 'Email', cell: (row: TotalCardOrder) => `${row.email}` },
    { columnDef: 'status', header: 'Status', cell: (row: TotalCardOrder) => `${row.statusName}` },

    // { columnDef: "city", header: "City", cell: (row: Order) => `${row.city}` },
    // { columnDef: "externalRef", header: "ExternalRef", cell: (row: Order) => `${row.externalRef}` },

    // { columnDef: "invoiceNumber", header: "Invoice number", cell: (row: TotalCardOrder) => `${row.invoiceNumber || "Voucher"}` },
    { columnDef: 'orderDate', header: 'Order date', cell: (row: TotalCardOrder) => `${toDateString(row.orderDate) || ''}` },
    // { columnDef: "partnerCustomerId", header: "Partner Customer ID", cell: (row: TotalCardOrder) => `${row.partnerCustomerId || ""}` },
  ];


  public dateFiltersList = [
    { name: 'dob', header: 'DOB' },
    { name: 'orderDate', header: 'Order date' },
  ];

  ngAfterViewInit(): void {

    this.checkAllButton();
  }

  checkAllButton() {
    try {
      this.allButton.checked = true;
      this.provenienceOrder = this.allButton.value === 1 ? 'from_assistant' : (this.allButton.value == 2 ? 'from_import' : 'from_anywhere');

    } catch (e) {
 console.log(e); 
}
  }

  onSearch(isInvalid = false) {
    if (!isInvalid) {
      this.table.applyFilter();
    }
  }


  getViewLink = (item: TotalCardOrder): string => 'order/' + item.id.toString();

  getEditLink = (item: TotalCardOrder): string => item.status >= TotalCardOrderStatus.Activated ? null : 'order/' + item.id.toString() + '/edit';

  currentUserIsPartner() {
    return this.roleService.hasRoles('partner');
  }

  editEnabled() {
    // return this.roleService.hasRoles("admin");
    return false;
  }

  deleteEnabled() {
    return this.roleService.hasRoles('admin');
  }

  multiselectEnabled() {
    return this.roleService.hasRoles(['admin', 'manager', 'agent', 'partner', 'compliance']);
  }

  filterOrdersByProvenience(source: number) {
    this.provenienceOrder = (source == 1 ? 'from_assistant' : (source == 2 ? 'from_import' : 'from_anywhere'));
    this.triggerSearch();
  }

  triggerSearch() {
    this.table.filters.someAdditionalData = this.provenienceOrder;
    this.table.filters.additionalFilterData = this.orderStatuses;
    this.onSearch();
  }

  groupTest(items: number[]) {
    if (items !== null) {
      this.orderStatuses = items.map(item => <string>TotalCardOrderStatus[item]);
    }
    this.triggerSearch();
  }

  exportOrders() {
    const idList = this.table.selection.selected.map(d => d.id);
    this.ordersService
      .export(idList).subscribe(result => {
      FileHelper.saveFile(result);

      this.ordersService.getStatuses(idList).subscribe(statuses => {
        statuses.forEach(x => {
          const order = this.dataSource.data.find(y => y.id == x.id);
          if (order) {
            order.status = x.status;
            order.statusName = x.statusName;
          }
        });
        this.changeDetectorRefs.detectChanges();
        this.table.refreshTable();
      });
    });
  }

  exportAllOrders() {
    this.ordersService.exportAllData(this.dataSource.filter)
      .subscribe(result => {
        FileHelper.saveFile(result);
      });
  }

  ngOnDestroy() {
    this.table.filters.someAdditionalData = '';
    this.orderStatuses = null;
    this.table.saveTableFilters();
  }

  uploadTotalCreations() {
    alert('CSV Format Definition is missing');
  }
  uploadTotalCancellations() {
    alert('CSV Format Definition is missing');
  }

  uploadTotalTransactions() {
    this.router.navigate(['/totalcard-orders/import-transactions']);
  }

}
